import { ApplicationCycle } from './ApplicationCycle';
import { PartnerSubCategoryProps } from './PartnerSubCategory';
import treeCampus from '../assets/logo-tree-campus.svg';
import treeCityWorldWide from '../assets/logo-tree-cities-world.svg';
import treeCityUSA from '../assets/logo-tree-city-usa.svg';
import treeline from '../assets/logo-tree-line.svg';

export interface ProgramProps {
  id: ProgramNames;
  programName: string;
  partnerTerm: string | null;
  partnerParentTerm: string;
  toolkitLink: string | null;
  displayAddress: boolean;
  displayCategory: boolean;
  displayLowestGrade: boolean;
  displayHighestGrade: boolean;
  applicationCycles: ApplicationCycle[];
  partnerSubCategories: PartnerSubCategoryProps[];
}

export interface ProgramApiResponse {
  id: ProgramNames;
  programName: string;
  partnerTerm: { [key: string]: string };
  partnerParentTerm: string;
  displayAddress: boolean;
  displayCategory: boolean;
  displaySchoolDistrict: boolean;
  displayLowestGrade: boolean;
  displayHighestGrade: boolean;
  applicationCycles: ApplicationCycle[];
  partnerSubCategories: PartnerSubCategoryApiResponse[];
  displayWorksWithSchools: boolean;
}

export interface PartnerSubCategoryApiResponse {
  id: number;
  subCategory: { [key: string]: string };
}

export enum ProgramNames {
  TreeCityUSA = 1,
  TreeCitiesWorld = 2,
  TreeLineUSA = 3,
  TreeCampusHigherEducation = 4,
  TreeCampusHealthcare = 5,
  TreeCampusK12 = 6,
  _ = 0,
}

export const CampusProgramIds = [
  ProgramNames.TreeCampusHigherEducation,
  ProgramNames.TreeCampusHealthcare,
  ProgramNames.TreeCampusK12,
];

export const GrowthAwardProgramIds = [ProgramNames.TreeCityUSA, ProgramNames.TreeCitiesWorld];

export const programIdToImage: { [key: string]: string } = {
  '1': treeCityUSA,
  '2': treeCityWorldWide,
  '3': treeline,
  '4': treeCampus,
  '5': treeCampus,
  '6': treeCampus,
};

export const programNameToId: { [key: string]: number } = {
  'Tree City USA': 1,
  'Tree Cities of the World': 2,
  'Tree Line USA': 3,
  'Tree Campus Higher Education': 4,
  'Tree Campus Healthcare': 5,
  'Tree Campus K-12': 6,
};

export const programIdToProgramName: { [key: number]: string } = {
  1: 'Tree City USA',
  2: 'Tree Cities of the World',
  3: 'Tree Line USA',
  4: 'Tree Campus Higher Education',
  5: 'Tree Campus Healthcare',
  6: 'Tree Campus K-12',
};

export const programIdToProgramShortName: { [key: number]: string } = {
  1: 'TCUSA',
  2: 'TCoW',
  3: 'TLine',
  4: 'TCHE',
  5: 'TCHC',
  6: 'TCK12',
};
